import getOptimizelyInstance from './getOptimizelyInstance';
let userIdCache;
export const setUserId = newUserId => {
  userIdCache = newUserId;
};

/**
 * Deprecated. Instead of this module, please import the `useOptimizelyTrack` hook to get proper context sensitivity:
 * `const optimizelyTrack = useOptimizelyTrack()`
 */
const optimizelyTrack = (eventKey, {
  userId = userIdCache,
  attributes,
  tags,
  value = tags && tags.value
} = {}) => getOptimizelyInstance().track(eventKey, userId, attributes, {
  ...tags,
  value
});
export default optimizelyTrack;